import { render, staticRenderFns } from "./ProductOptionSelector.vue?vue&type=template&id=1a309eea&scoped=true&"
import script from "./ProductOptionSelector.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionSelector.vue?vue&type=style&index=0&id=1a309eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a309eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a309eea')) {
      api.createRecord('1a309eea', component.options)
    } else {
      api.reload('1a309eea', component.options)
    }
    module.hot.accept("./ProductOptionSelector.vue?vue&type=template&id=1a309eea&scoped=true&", function () {
      api.rerender('1a309eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/shop/ProductOptionSelector.vue"
export default component.exports